import React from "react";
import { COLORS } from "shared/consts";
import {IconProps} from './index.tsx';

export const KeyPassword: React.FC<IconProps> = ({
                                            fill = COLORS.FG.SOFT,
                                            width = 24,
                                            height = 24,
                                            className,
                                          }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M10.6763 10.4971L10.0665 11.0393L4.5 15.9881V18.5024H6.90675L7.85657 17.6499L6.63354 16.3104L7.74127 15.299L8.97294 16.648L9.96407 15.7584L8.71345 14.3983L9.81762 13.383L11.0805 14.7564L12.3184 13.6454L12.9389 13.0885L13.7395 13.3215C14.1377 13.4374 14.5602 13.5 15 13.5C17.4853 13.5 19.5 11.4853 19.5 9C19.5 6.51472 17.4853 4.5 15 4.5C12.5147 4.5 10.5 6.51472 10.5 9C10.5 9.23573 10.518 9.46627 10.5524 9.69055L10.6763 10.4971ZM7.76616 19.7466L13.3203 14.7617C13.8533 14.9168 14.4169 15 15 15C18.3137 15 21 12.3137 21 9C21 5.68629 18.3137 3 15 3C11.6863 3 9 5.68629 9 9C9 9.31223 9.02385 9.61888 9.06982 9.91825L3.33557 15.0163C3.12212 15.206 3 15.478 3 15.7636V19.0024C3 19.5547 3.44772 20.0024 4 20.0024H7.09822C7.34478 20.0024 7.58266 19.9113 7.76616 19.7466ZM15.5045 10.0063C16.3354 10.0063 17.009 9.3333 17.009 8.50314C17.009 7.67298 16.3354 7 15.5045 7C14.6736 7 14 7.67298 14 8.50314C14 9.3333 14.6736 10.0063 15.5045 10.0063Z"
        fill={fill}
      />
    </svg>
  );
};